import { Notification } from "@/types/globalTypes";
import { timeAgo } from "@/utils/helpers";

import { typeToIcon, useNotifications } from "@/contexts/NotificationsContext";
import { useTranslation } from "react-i18next";
import i18n from "@/i18n";
import { useUserRole } from "@/hooks/useUserRole";



function NotificationItem({ notification }: { notification: Notification }) {
  const { t } = useTranslation();
  const lang = i18n.language;
  const { handleMarkAsReadWithSearch, markAsRead, markAsReadWithNavigate } =
    useNotifications();
  const { isAdmin, isBranchAdmin } = useUserRole();
  const isFromAdmins = isAdmin || isBranchAdmin;
  const notificationCursorShowningCondition =
    (notification.type === "order-received" && isFromAdmins) ||
    !notification.read;

  const isTypeOrderReceived = notification.type === "order-received";
  const isTypeSubscription =
    notification.type === "subscription-day-alarm" ||
    notification.type === "subscription-week-alarm" ||
    notification.type === "subscription-month-alarm" ||
    notification.type === "subscription-expired";

  const isTypeReviewed = notification.type === "order-reviewed";

  const handleNotificationClick = () => {
    if (isTypeOrderReceived) {
      handleMarkAsReadWithSearch(notification);
    } else if (isTypeSubscription) {
      markAsReadWithNavigate(notification, "/settings/subscribtion");
    } else if (isTypeReviewed) {
      if (notification.read) return;
      else markAsReadWithNavigate(notification,`/orders/reviews?id=${notification.meta?.orderId}`);
    } else if (!notification.read) {
      markAsRead([notification.id] as string[]);
    } else {
      return null;
    }
  };

  return (
    <div
      onClick={handleNotificationClick}
      className={`card flex justify-start gap-16 rounded-md border border-gray-200 px-8 py-5 ${notificationCursorShowningCondition ? "cursor-pointer" : "cursor-default"} ${
        notification.read ? "bg-white" : "bg-sky-50"
      }`}
    >
      <div className="flex items-center gap-4">
        <div className="flex w-[40px] items-center justify-center">
          {/* React Icon Based on Type */}
          {typeToIcon[notification.type]}
        </div>
        <div className="flex flex-col gap-2">
          <h3 className="m-0 flex items-center gap-5 p-0 text-sm font-semibold">
            {t(notification.titleEN, notification.titleAR)}
            <span className="self-end text-[12px] text-slate-500">
              {timeAgo(notification.time * 1000, lang)}
            </span>
          </h3>
          <p className="m-0 p-0 text-sm text-slate-500">
            {t(notification.contentEN, notification.contentAR)}
          </p>
        </div>
      </div>
    </div>
  );
}

export default NotificationItem;
